import { Heart, ShieldCheck, Sparkles, Users, ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import { Reveal, MaskedLine, SectionHeading } from "@/components/Reveal";
import { Marquee } from "@/components/Marquee";

const VALUES = [
  { icon: Heart, title: "Passion for Beauty", desc: "Lebih dari sekadar perawatan — kami hadir untuk membuat setiap orang merasa cantik, percaya diri, dan nyaman dari ujung kaki hingga kepala. Kecantikan adalah kebahagiaan, dan itulah misi kami." },
  { icon: ShieldCheck, title: "Privasi & Kenyamanan", desc: "Ruangan hijab privat, area spa eksklusif, dan suasana yang tenang & aman. Privasi tamu adalah prioritas utama kami — setiap kunjungan terasa seperti di rumah sendiri." },
  { icon: Sparkles, title: "Premium Quality", desc: "Menggunakan produk internasional berkualitas untuk rambut, kulit, dan tubuh. Hasil tahan lama, aman, dan lembut — karena kecantikan tidak harus mengorbankan kesehatanmu." },
  { icon: Users, title: "Tim Bersertifikat", desc: "Tim stylist, terapis, dan pengajar bersertifikat lengkap yang terus berlatih & mengikuti tren terkini — agar kamu selalu mendapatkan pelayanan terbaik berstandar internasional." },
];

export default function About() {
  return (
    <div data-testid="about-page" className="pt-32 pb-0">
      <div className="mx-auto max-w-7xl px-5 sm:px-8 pb-20">
        <MaskedLine delay={0.1}><p className="overline-label">Tentang Kami</p></MaskedLine>
        <h1 className="mt-4 font-cinzel font-black text-brand-burgundy text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-[1.05]">
          <MaskedLine delay={0.25}>MORE THAN</MaskedLine>
          <MaskedLine delay={0.4} innerClassName="text-gold-gradient">A SALON.</MaskedLine>
        </h1>
      </div>

      <div className="mx-auto max-w-7xl px-5 sm:px-8 pb-24 grid gap-14 lg:grid-cols-2 lg:items-center">
        <Reveal>
          <div className="overflow-hidden rounded-sm gold-foil-border">
            <img
              src={`${process.env.REACT_APP_BACKEND_URL}/api/files/salon-beauty-bar/uploads/aee10fd4-322b-4a9b-93bc-e7a5e0679a62.jpg`}
              alt="Tampak depan Strawberry Beauty Bar, Kota Bandung"
              loading="lazy"
              className="aspect-[4/3] w-full object-cover"
            />
          </div>
        </Reveal>
        <div>
          <SectionHeading index="01" overline="Cerita Kami" title="Berawal dari Kecintaan pada Seni Kecantikan" />
          <Reveal delay={0.15}>
            <div className="space-y-5 text-base leading-relaxed text-brand-ink-muted">
              <p>
                Berdiri sejak tahun 2000, Salon Strawberry Beauty Bar terus berkembang menjadi salah satu destinasi kecantikan terpercaya dengan 37 cabang yang tersebar di Bandung dan berbagai kota lainnya seperti Bali, Bekasi, Cibubur, dan Tasikmalaya.
              </p>
              <p>
                Didukung oleh 100+ tenaga profesional dengan pengalaman puluhan tahun di dunia kecantikan, kami menghadirkan berbagai layanan dalam satu tempat — mulai dari Hair Treatment, Klinik Kecantikan, Body Massage, Nail Art, Hijab Room, Salon Kids, hingga Beauty Academy & Kursus Salon.
              </p>
              <p>
                Dengan pengalaman lebih dari dua dekade, kami telah melayani ribuan pelanggan dan terus berkomitmen memberikan pelayanan terbaik.
              </p>
              <p className="font-serif italic text-brand-burgundy">
                Datang untuk mempercantik diri, pulang dengan rasa percaya diri. — Salon Strawberry Beauty Bar
              </p>
            </div>
          </Reveal>
          <Reveal delay={0.25}>
            <div className="mt-10 grid grid-cols-2 sm:grid-cols-4 gap-6 border-t border-brand-gold/25 pt-8" data-testid="about-stats">
              {[["25+", "Tahun Berkarya"], ["37", "Cabang di Indonesia"], ["100+", "Tenaga Profesional"], ["Ribuan+", "Pelanggan Setia"]].map(([v, l]) => (
                <div key={l}>
                  <p className="font-serif text-3xl font-bold text-gold-gradient">{v}</p>
                  <p className="mt-1 text-[10px] uppercase tracking-[0.2em] text-brand-ink-muted">{l}</p>
                </div>
              ))}
            </div>
          </Reveal>
        </div>
      </div>

      <Marquee />

      <div className="mx-auto max-w-7xl px-5 sm:px-8 py-24">
        <SectionHeading index="02" overline="Nilai Kami" title="Mengapa Salon Strawberry Official" center />
        <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {VALUES.map((v, i) => (
            <Reveal key={v.title} delay={i * 0.1}>
              <div data-testid={`about-value-${i}`} className="group h-full rounded-sm bg-white gold-foil-border p-8 text-center transition-all duration-500 hover:-translate-y-2 hover:bg-brand-burgundy">
                <div className="mx-auto flex h-14 w-14 items-center justify-center rounded-full bg-brand-paper text-brand-burgundy transition-colors duration-500 group-hover:bg-brand-gold group-hover:text-brand-ink">
                  <v.icon size={24} />
                </div>
                <h3 className="mt-5 font-serif text-lg font-semibold text-brand-burgundy transition-colors duration-500 group-hover:text-brand-cream">{v.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-brand-ink-muted transition-colors duration-500 group-hover:text-brand-cream/70">{v.desc}</p>
              </div>
            </Reveal>
          ))}
        </div>
        <Reveal delay={0.3} className="mt-14 text-center">
          <Link
            data-testid="about-cta-btn"
            to="/kontak"
            className="inline-flex items-center gap-3 rounded-full bg-brand-burgundy px-8 py-4 text-xs font-bold uppercase tracking-[0.2em] text-brand-cream transition-all duration-300 hover:bg-brand-gold hover:text-brand-ink"
          >
            Rasakan Pengalamannya <ArrowRight size={15} />
          </Link>
        </Reveal>
      </div>
    </div>
  );
}
